import React from "react";
import { Helmet } from "react-helmet-async";
import { useLang } from "../i18n/LanguageContext";

const SITE = "Global Marketing";
const DEFAULT_OG = "https://customer-assets.emergentagent.com/job_modern-merchandising-1/artifacts/ctl3aug9_Screenshot%202026-05-04%20at%2013.26.02.png";

/**
 * Per-page SEO meta tags driven by the active language.
 * Pass `cs` and `en` strings for both `title` and `description`.
 * Optional: image (absolute URL), path (canonical relative path).
 */
export default function Seo({ title, description, image = DEFAULT_OG, path = "" }) {
  const { lang } = useLang();
  const t = (typeof title === "string" ? title : title?.[lang]) || SITE;
  const d = (typeof description === "string" ? description : description?.[lang]) || "";
  const fullTitle = t.includes(SITE) ? t : `${t} · ${SITE}`;
  const url = `https://globalmarketing.cz${path}`;

  return (
    <Helmet>
      <html lang={lang === "en" ? "en" : "cs"} />
      <title>{fullTitle}</title>
      <meta name="description" content={d} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={d} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={lang === "en" ? "en_GB" : "cs_CZ"} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={d} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
